import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e62be748"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-renderer-id"]
const _hoisted_2 = {
  key: 0,
  class: "color-red"
}
const _hoisted_3 = { class: "d-flex flex-row align-items-center" }
const _hoisted_4 = { class: "injected-array-tag-text" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["id", "title", "aria-label", "disabled"]
const _hoisted_7 = { class: "accordion-collapse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_dispatch_renderer = _resolveComponent("dispatch-renderer")!
  const _component_array_list_element = _resolveComponent("array-list-element")!
  const _component_FunctionSelector = _resolveComponent("FunctionSelector")!

  return (_ctx.control.visible)
    ? (_openBlock(), _createElementBlock("fieldset", {
        key: 0,
        class: _normalizeClass(_ctx.styles.arrayList.root),
        style: {"border-left":"3px solid #e3e3e3"},
        "data-renderer-id": _ctx.RendererConfigurations.ArrayListRenderer.name
      }, [
        _createElementVNode("legend", {
          class: _normalizeClass([_ctx.styles.arrayList.legend, "d-flex flex-row justify-content-between margin-0 array-list-legend-custom"])
        }, [
          _createElementVNode("label", {
            class: "d-flex flex-row align-items-center font-size-14 cursor-pointer full-width pd-l-5",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle = !_ctx.toggle))
          }, [
            _createTextVNode(_toDisplayString(_ctx.control.label), 1),
            (_ctx.control.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.injectedReference)
              ? (_openBlock(), _createBlock(_component_ElTag, {
                  key: 0,
                  id: `${_ctx.control.id}-injected-tag`,
                  title: _ctx.injectedLabel,
                  class: "injected-array-tag",
                  size: "small",
                  type: "info",
                  closable: _ctx.control.enabled,
                  onClose: _ctx.removeInjection
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.injectedLabel), 1)
                  ]),
                  _: 1
                }, 8, ["id", "title", "closable", "onClose"]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addButtonClick && _ctx.addButtonClick(...args))),
              disabled: !!_ctx.injectedReference,
              type: "button"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "plus",
                size: "xs"
              })
            ], 8, _hoisted_5),
            (_ctx.injectable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  id: `${_ctx.control.id}-inject-btn`,
                  class: "btn btn-link",
                  type: "button",
                  title: _ctx.t('Flow.InjectVariableIntoArray'),
                  "aria-label": _ctx.t('Flow.InjectVariableIntoArray'),
                  disabled: !_ctx.control.enabled,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleInjectionDrawer && _ctx.toggleInjectionDrawer(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "database",
                    size: "xs"
                  })
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (!_ctx.injectedReference)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.control.data, (element, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${_ctx.control.path}-${index}`,
                class: _normalizeClass([_ctx.styles.arrayList.itemWrapper, "accordion"])
              }, [
                _withDirectives(_createVNode(_component_array_list_element, {
                  delete: _ctx.removeItems(_ctx.control.path, [index]),
                  label: `${_ctx.control.label} - ${index + 1}`,
                  styles: _ctx.styles
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_dispatch_renderer, {
                        schema: _ctx.control.schema,
                        uischema: _ctx.childUiSchema,
                        path: _ctx.composePaths(_ctx.control.path, `${index}`),
                        onHandleClickEvent: _ctx.handleClickEvent,
                        onExpressionDrawer: _ctx.expressionDrawer,
                        enabled: _ctx.control.enabled,
                        stepIdx: _ctx.stepIdx,
                        outputList: _ctx.outputList,
                        expressions: _ctx.expressions,
                        metaoutputList: _ctx.metaoutputList,
                        userDefinedVariables: _ctx.userDefinedVariables,
                        systemVariables: _ctx.systemVariables,
                        renderers: _ctx.control.renderers,
                        cells: _ctx.control.cells,
                        class: "accordion-body pl-20",
                        style: {"border-left":"4px solid #f3f3f3 !important"}
                      }, null, 8, ["schema", "uischema", "path", "onHandleClickEvent", "onExpressionDrawer", "enabled", "stepIdx", "outputList", "expressions", "metaoutputList", "userDefinedVariables", "systemVariables", "renderers", "cells"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["delete", "label", "styles"]), [
                  [_vShow, _ctx.toggle]
                ])
              ], 2))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.injectable)
          ? (_openBlock(), _createBlock(_component_FunctionSelector, {
              key: 1,
              "output-list": _ctx.outputList,
              "user-defined-variables": _ctx.userDefinedVariables,
              "system-variables": _ctx.systemVariables,
              expressions: _ctx.expressions,
              "metaoutput-list": _ctx.metaoutputList,
              "id-prefix": _ctx.control.id,
              "drawer-key": _ctx.control.id,
              mode: "input",
              "show-other-inputs": true,
              showMeta: true,
              visible: _ctx.drawerVisible,
              onAddOutput: _ctx.onAddOutput,
              onAddMetaoutput: _ctx.onAddMetaoutput,
              onAddUserVariable: _ctx.onAddUserVariable
            }, null, 8, ["output-list", "user-defined-variables", "system-variables", "expressions", "metaoutput-list", "id-prefix", "drawer-key", "visible", "onAddOutput", "onAddMetaoutput", "onAddUserVariable"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}